const calculateItemSalePrice = (item) => (
  item.salePrice - Math.min(item.systemDiscount / item.quantity, 0)
)

export default calculateItemSalePrice